import {
  ID,
  Evaluation,
  EvaluationCheck,
  Model,
  ModelConnection,
  TaskType,
  ColumnsConfig,
  REDACTED_COLUMN,
  TYPE_COLUMN,
  PARAPHRASE,
} from './types'
import {Get, Post, Put, Delete} from './server'

export const createEvaluation = async (e: Evaluation): Promise<Evaluation> => Post('/evaluation', e)
export const getEvaluation = async (evalID: ID): Promise<Evaluation> =>
  Get('/evaluation', {id: evalID})
export const updateEvaluation = async (e: Evaluation) => Put('/evaluation', e)

export const connectModels = async (connections: ModelConnection[]) =>
  Post('/modelsconnecter', {connections})

export const getModelConnections = async (
  item: Model | Evaluation,
  item_type: 'model' | 'evaluation'
) => Get('/modelsconnecter', {[item_type === 'model' ? 'evaluatee_id' : 'evaluation_id']: item.id})

export const removeSubscription = async ({id}: ModelConnection) => Delete('/modelsconnecter', {id})

export const checkEvaluationUrl = async (
  csv_url: string,
  default_task_type?: TaskType,
  config?: ColumnsConfig
): Promise<EvaluationCheck> => {
  const params =
    config &&
    Object.entries(config).reduce(
      (acc, [col, conf]) => {
        if (!conf.columnType) {
          return acc
        } else if ([REDACTED_COLUMN, TYPE_COLUMN].includes(conf.columnType)) {
          acc[conf.columnType] = col
        } else if (conf.columnType === PARAPHRASE) {
          if (conf.paraphraseOf) acc[`paraphrase.${col}`] = conf.paraphraseOf
        } else {
          const colType = conf.columnType.toLowerCase()
          const current = acc[colType]
          const encoded = encodeURIComponent(col)
          acc[colType] = current ? `${current},${encoded}` : encoded
        }
        return acc
      },
      {csv_url, default_task_type} as {[k: string]: string}
    )
  return Get('/evaluationbuilderhandler', params)
}

export const fetchEvaluationTasksHeaders = async (url: string): Promise<EvaluationCheck> =>
  Get('/evaluationbuilderhandler', {csv_url: url, only_header: true})
